import { forwardRef } from 'react';
import classNames from 'classnames';

interface ResponsiveWrapperProps {
  customClass?: string;
  children?: React.ReactNode;
}

const ResponsiveWrapper = forwardRef<HTMLDivElement, ResponsiveWrapperProps>(
  ({ customClass = '', children }, ref) => (
    <div ref={ref} className={classNames('flex-1 px-8 w-full', customClass)}>
      {children}
    </div>
  )
);

export default ResponsiveWrapper;
